<template>
  <div>
    <v-col class="container pa-5 py-4">
      <ToolbarTitles :title="title" />
    </v-col>
    <div class="container">
      <TableWithSearch
        :items="getAttributes"
        :headers="allHeaders"
        :openDialog="openDialog"
        :showPagination="false"
        @headersUpdated="updateHeaders"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        :max-width="maxWidth"
        persistent
        @keydown.esc="reset(false)"
      >
        <FormAttributes
          :key="formKey"
          :maxWidth="maxWidth"
          :title="modeForm"
          @save="save"
          @cancel="reset"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
      <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
    </div>
  </div>
</template>
<script>
import TableWithSearch from "../../Complement/TableWithSearch.vue";
import FormAttributes from "./Form/FormAttributes.vue";
import DeleteDialog from "../../Complement/DeleteDialog.vue";
import Snackbar from "../../Complement/Snackbar.vue";
import attributes from "../../../store/atributos/attributes";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  name: "labels",
  components: {
    TableWithSearch,
    FormAttributes,
    DeleteDialog,
    Snackbar,
    ToolbarTitles,
  },
  data() {
    return {
      title: "Atributos",
      titleTable: "DefAtributos",
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Descripción",
          value: "description",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Tipo",
          value: "type",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Valores",
          value: "values",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      showForm: false,
      showDelete: false,
      itemDelete: null,
      alert: false,
      textAlert: "",
      color: "",
      formKey: 0,
      titleDelete: this.$tc("attributes.deleteAttribute"),
      modoItem: "",
      maxWidth: "550px",
      itemToDelete: null,
      oldItems: null,
    };
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    attributes.dispatch("getAttributes");
  },
  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    getAttributes() {
      return attributes.state.attributes;
    },
    modeForm: {
      get() {
        return attributes.state.modeForm;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return attributes.state.openform;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete() {
      return attributes.state.openDelete;
    },
  },
  methods: {
    async refreshItems() {
      await attributes.dispatch("getAttributes");
    },
    updateHeaders(headers) {
      const updatedColums = headers;

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = this.allHeaders;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };

      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        this.showAlert(this.$tc("commons.savedColumnSetting"), "#82A1D0");
        configTable.commit("setNew", []);
      });
    },
    async openDialog(type, item) {
      this.typeForm = type;
      this.formKey++;
      switch (this.typeForm) {
        case "add":
          this.modoItem = "add";
          this.oldItems = null;
          attributes.commit(
            "setModeForm",
            this.$tc("attributes.addAttributes")
          );
          attributes.commit("setOpenform", true);
          break;
        case "edit":
          this.modoItem = "edit";
          attributes.commit("setEdit", item);
          attributes.commit(
            "setModeForm",
            this.$tc("attributes.editAttributes")
          );
          attributes.commit("setOpenform", true);
          break;
        case "delete":
          attributes.commit("setOpenDelete", true);
          this.itemToDelete = item;
          break;
        default:
          break;
      }
    },

    reset(value) {
      attributes.commit("setOpenform", value);
      attributes.commit("setEdit", []);
    },

    cancelDelete() {
      attributes.commit("setOpenDelete", false);
    },

    deleteItem() {
      attributes.commit("setItemDelete", this.itemToDelete);
      attributes
        .dispatch("deleteAttribute")
        .then(() => {
          attributes.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("attributes.deleteAttributesSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#FF8D58");
        });
    },

    save(items) {
      switch (this.typeForm) {
        case "add":
          this.addAttributes(items);
          break;
        case "edit":
          this.editAttributes(items);
          break;
        default:
          break;
      }
    },

    sendEdit(updatedItem) {
      attributes.commit("setEdit", updatedItem);
      attributes
        .dispatch("editAttribute")
        .then(() => {
          this.showAlert(
            this.$tc("attributes.editAttributeSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.xmessage, "#ff8d58");
        });
      this.reset(false);
    },

    editAttributes(item) {
      const changes = {};
      const itemOld = attributes.state.edit;
      if (itemOld.name !== item.name) {
        changes.name = item.name;
      }

      if (itemOld.description !== item.description) {
        changes.description = item.description;
      }

      if (itemOld.type !== item.type) {
        if (item.type !== "Lista") {
          delete item.values;
          delete itemOld.values;
        }
        changes.type = item.type;
      }

      if (item.values !== null && item.values !== undefined) {
        if (itemOld.hasOwnProperty("values")) {
          if (itemOld.values !== item.values) {
            changes.values = item.values;
          }
        } else {
          changes.values = item.values;
        }
      }

      if (Object.keys(changes).length > 0) {
        const updatedItem = { atribId: itemOld.atribId, ...changes };
        this.sendEdit(updatedItem);
      } else {
        this.showAlert(this.$tc("reports.editLabelAlert"), "#f1c232");
      }
    },

    async addAttributes(item) {
      await attributes.commit("setNewAttribute", item);
      attributes
        .dispatch("addAttributes")
        .then(() => {
          this.showAlert(this.$tc("attributes.addAttributeSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#ff8d58");
        });
      this.reset(false);
    },

    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
  },
};
</script>
<style>
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
